import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  useTheme,
  useMediaQuery
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DataPreviewTable from './DataPreviewTable';
import { InvoiceItem } from '../config/types';

interface DataPreviewDialogProps {
  open: boolean;
  onClose: () => void;
  entries: InvoiceItem[];
  onDeleteEntry: (index: number) => void;
  onEditEntry: (index: number) => void;
  onDownloadInvoice: (entry: InvoiceItem) => Promise<void>;
  onDownloadPdf: (entry: InvoiceItem) => Promise<void>;
  onDownloadAll: (onProgress: (done: number, total: number) => void) => Promise<void>;
  onSplitEntries: (selectedIndices: number[]) => void;
}

const DataPreviewDialog: React.FC<DataPreviewDialogProps> = ({
  open,
  onClose,
  entries,
  onDeleteEntry,
  onEditEntry,
  onDownloadInvoice,
  onDownloadPdf,
  onDownloadAll,
  onSplitEntries
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      fullScreen={fullScreen}
      maxWidth="xl"
      fullWidth
      open={open}
      onClose={onClose}
      aria-labelledby="data-preview-dialog"
      PaperProps={{
        // Desktop: 90% of the viewport. Phones: true full screen.
        sx: fullScreen ? undefined : { height: '90vh', maxHeight: '90vh' }
      }}
    >
      <DialogTitle id="data-preview-dialog">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          Data Preview
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent 
        dividers 
        sx={{ 
          p: 0,
          display: 'flex',
          flexDirection: 'column',
          height: '100%' // Take up all available space
        }}
      >
        <DataPreviewTable
          entries={entries}
          onDeleteEntry={onDeleteEntry}
          onEditEntry={onEditEntry}
          onDownloadInvoice={onDownloadInvoice}
          onDownloadPdf={onDownloadPdf}
          onDownloadAll={onDownloadAll}
          onSplitEntries={onSplitEntries}
        />
      </DialogContent>
    </Dialog>
  );
};

export default DataPreviewDialog; 